// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"f712f300","751":"a1a283d7","773":"60ea8234","828":"c26642e9"}[chunkId] + ".chunk.css";
};